import { AppointmentInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const AppointmentInputSchema: z.ZodType<AppointmentInput> = z.object({
  status: z.enum([
    "aguardando",
    "agendado",
    "concluido",
    "cancelado",
    "recusado",
    "em andamento",
    "pendente",
  ]),
  reason_for_cancellation: z.string().optional(),
  cancel_recurrency: z.boolean().optional(),
  timer: z.string().optional(),
});
